<template>
    <div id="root">
        <div class="cNPqRG">
            <div class="hvZODy">
                <div class="fUeRVh elmSvn">
                    <div class="gRvIYK">
                        <div class="icon">
                            <img src="../assets/logo.jpg" alt="" class="img">
                        </div>
                        <span>Kjrfeevx</span>
                    </div>
                    <div class="blahbA">
                        <div class="pcMenu">
                            <a class="menuItem " href="#Home">首頁</a>
                            <a class="menuItem " href="#IFO">IFO</a>
                            <a class="menuItem " href="#Collection">藏品</a>
                            <a class="menuItem " href="#Genesis">合夥人</a>
                            <!-- <a class="menuItem " href="#Pool">礦池</a> -->
                            <a class="menuItem " href="#Referral">邀請</a>
                        </div>
                        <div class="phoneMenu">
                            <div class="ant-dropdown-trigger ant-dropdown-link">
                                <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2221"  @click="showMainMenu">
                                    <path d="M110.025 252.249c0 13.741 5.456 27.374 14.899 37.112s22.663 15.364 35.987 15.364 26.544-5.626 35.987-15.364c9.441-9.738 14.899-23.371 14.899-37.112s-5.456-27.375-14.899-37.111c-9.442-9.738-22.663-15.364-35.987-15.364s-26.544 5.626-35.987 15.364c-9.338 9.736-14.899 23.37-14.899 37.111m0 0zM103.625 512.575c0 13.741 5.455 27.482 14.899 37.22 9.442 9.738 22.663 15.364 36.091 15.364 13.324 0 26.649-5.626 36.091-15.364s14.899-23.371 14.899-37.22c0-13.741-5.455-27.482-14.899-37.22-9.442-9.738-22.662-15.364-36.091-15.364-13.324 0-26.649 5.626-36.091 15.364-9.444 9.737-14.899 23.37-14.899 37.22m0 0zM103.625 774.089c0 13.741 5.455 27.482 14.899 37.22 9.442 9.738 22.663 15.364 36.091 15.364 13.324 0 26.649-5.626 36.091-15.364s14.899-23.37 14.899-37.22c0-13.741-5.455-27.482-14.899-37.22-9.442-9.737-22.662-15.364-36.091-15.364-13.324 0-26.649 5.627-36.091 15.364-9.444 9.847-14.899 23.479-14.899 37.22m0 0zM919.041 249.869c0 27.699-19.935 50.095-44.59 50.095H345.88c-24.655 0-44.59-22.397-44.59-50.095 0-27.699 19.935-50.095 44.59-50.095h528.571c24.656-0.001 44.59 22.396 44.59 50.095m0 0zM919.041 510.195c0 27.59-19.935 50.095-44.59 50.095H345.88c-24.655 0-44.59-22.398-44.59-50.096 0-27.699 19.935-50.096 44.59-50.096h528.571c24.656-0.109 44.59 22.397 44.59 50.097m0 0zM919.041 771.601c0 27.699-19.935 50.096-44.59 50.096H345.88c-24.655 0-44.59-22.397-44.59-50.096 0-27.591 19.935-49.988 44.59-49.988h528.571c24.656-0.108 44.59 22.397 44.59 49.988m0 0z" p-id="2222"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="sc-eCYdqJ NZQce">
                        <div class="ant-select dOQbkG ant-select-single ant-select-show-arrow">
                            <div class="ant-select-selector">
                                <span class="ant-select-selection-search">
                                    <input type="search" autocomplete="off" class="ant-select-selection-search-input" role="combobox" aria-haspopup="listbox" aria-owns="rc_select_0_list" aria-autocomplete="list" aria-controls="rc_select_0_list" aria-activedescendant="rc_select_0_list_0" readonly="" unselectable="on" value="" id="rc_select_0" style="opacity: 0;">
                                </span>
                                <span class="ant-select-selection-item" title="繁體中文" @click="showLanguageMenu">繁體中文</span>
                            </div>
                            <span class="ant-select-arrow" unselectable="on" aria-hidden="true" style="user-select: none;">
                                <span role="img" aria-label="down" class="anticon anticon-down ant-select-suffix">
                                    <svg viewBox="64 64 896 896" focusable="false" data-icon="down" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                        <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
                                    </svg>
                                </span>
                            </span>
                        </div>
                    </div>
                    <button type="button" class="ant-btn ant-btn-default hTLDKO gwMTjx">
                        <span>{{account.length===42?account.substring(0,6)+"..."+account.substring(38,42):''}}</span>
                    </button>
                </div>
            </div>
            <div class="gCWRlV">
                <div class="first newfirst" id="Home">
                    <div class="fUeRVh content" style="display:block;text-align:center;">
                            <div class="firstHand">Welcome to Kjrfeevx</div>
                            <div class="firstIntro">Kjrfeevx NFT Swap 是新一代去中心化的聚合平臺，為全球數位愛好者、創作者和收藏家不断迭代。</div>
                            <div class="btnBox">
                                <button type="button" class="ant-btn ant-btn-default hTLDKO kmPhYp newkmPhYp">
                                    <a rel="noreferrer" href="#Genesis">成為创世者</a>
                                </button>
                            </div>
                            <div class="count-detail">
                                <div class="item">
                                    <div class="number">0.3 U</div>
                                    <div class="text">價格</div>
                                </div>
                                <div class="item">
                                    <div class="number">6600000</div>
                                    <div class="text">流通量</div>
                                </div>
                                <div class="item">
                                    <div class="number">{{nftTotalSupply}}</div>
                                    <div class="text">全網藏品</div>
                                </div>
                            </div>
                            <div class="card-body">
                                    <button type="button" class="ant-btn ant-btn-default hTLDKO kmPhYp kmPhYpmoney" @click="approve" v-if="buyBtn=='錢包授權'">
                                        <span>錢包授權</span>
                                    </button>
                                    <a  class="ant-btn ant-btn-default hTLDKO kmPhYp kmPhYpmoney" style="padding-top: 10px" href="#BUY" v-if="buyBtn=='參與'">參與</a>
                           </div>
                    </div>
                </div>

                <div class="first two">
                    <div class="hrefLine" id="IFO"></div>

                    <div class="fUeRVh content">
                        <div class="left">
                            <div class="icoHand newicoHand newicoIFO">IFO</div>
                            <div class="name newname"># Kjrfeevx NFT</div>
                            <div class="icoIntro newicoIntro">參加IFO會給你不同類型的盲盒,
                                 <br><br>以及打開非功能性收藏品的機會。(0.3 USDT = 1 KJF)
                            </div>
                            <div class="hrefLine" id="BUY"></div>
                            <div class="btnBox">
                                            <button type="button" class="ant-btn ant-btn-default hTLDKO kmPhYp twokmPhYp" @click="buy(buyAmountLimit)">
                                                <span>購買KJF</span>
                                            </button>
                            </div>
                            <div class="infoBox">
                                <div class="price">
                                    <div class="number newnumber">0.3 USDT</div>
                                    <div class="text newtext">價格</div>
                                </div>
                                <div class="price total">
                                    <div class="number newnumber">333</div>
                                    <div class="text newtext">每個用戶限量</div>
                                </div>
                                 <div class="price total">
                                    <div class="number newnumber">{{userInfo.usdtBalance}} USDT</div>
                                    <div class="text newtext">餘額</div>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="card">
                                <div class="icon">
                                    <img src="../../public/static/media/nft1.png" alt="" class="img">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="first three">
                    <div class="hrefLine" id="Collection"></div>
                    <div class="fUeRVh content newcontent">
                        <div class="left">
                            <div class="collectionHand newicoHand">藏品</div>
                            <div class="newleft">
                                <div class="noData newnoData" v-if="userInfo.nftList.length==0">
                                    <p>
                                        <img src="../assets/not.png" alt="" class="img" style="width:50%;margin:0 auto;">
                                    </p>
                                    <p style="text-align:center;">沒有可用的卡牌 ...</p>
                                </div>
                                <div class="icoList" v-else>
                                    <div class="noData">我的卡牌</div>
                                    <div class="icoItem">
                                        <div class="picture">
                                            <img src="../../public/static/media/nft2.png" alt="" class="img">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right newright getnewright">
                            <div class="ant-spin-nested-loading">
                                <div class="ant-spin-container">
                                    <div class="pendingReward newpendingReward"  style="margin-top:24px;">
                                        <div class="text"><p class="getmoney">{{userInfo.lpRemainReward}} USDT</p>待領取LP收益
                                        </div>
                                        <div class="number">
                                            <button disabled="" type="button" class="ant-btn ant-btn-default hTLDKO SRwGx newSRwGx">
                                                <span>領 取</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ant-spin-nested-loading">
                                <div class="ant-spin-container">
                                    <div class="pendingReward newpendingReward">
                                        <div class="text"> <p class="getmoney">{{userInfo.nodeRemainReward}} USDT</p>超級節點
                                        </div>
                                        <div class="number">
                                            <button disabled="" type="button" class="ant-btn ant-btn-default hTLDKO SRwGx" v-if="userInfo.nodeRemainReward==0">
                                                <span>領 取</span>
                                            </button>
                                            <button type="button" class="ant-btn ant-btn-default hTLDKO SRwGx newSRwGx" @click="claimNodeReward" v-else>
                                                <span>領 取</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ant-spin-nested-loading">
                                <div class="ant-spin-container">
                                    <div class="pendingReward newpendingReward">
                                        <div class="text"><p class="getmoney">{{userInfo.nftRemainReward}} USDT</p>NFT分紅收益
                                        </div>
                                        <div class="number">
                                            <button disabled="" type="button" class="ant-btn ant-btn-default hTLDKO SRwGx" v-if="userInfo.nftRemainReward==0">
                                                <span>領 取</span>
                                            </button>
                                            <button type="button" class="ant-btn ant-btn-default hTLDKO SRwGx newSRwGx" @click="claimNftReward" v-else>
                                                <span>領 取</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="first three" style="margin-bottom:0;">
                    <div class="hrefLine" id="Referral"></div>
                    <div class="fUeRVh content getcontent">
                        <div class="left">
                            <div class="collectionHand newicoHand getnewicoHand">成為创世者</div>
                            <div class="newleft">
                                <div class="title newtitle">我的邀請連結</div>
                                <div class="text copytext">
                                    <!-- <img style="width:20px;margin-top:6px;margin-right:6px" alt="" class="contract-copy" :data-clipboard-text="referUrl" @click="copy('.contract-copy')"/> -->
                                    <span class="copylink">{{referUrl | handleText}}</span>
                                    <span :data-clipboard-text="referUrl" class="contract-copy" @click="copy('.contract-copy')">Copy</span>

                                </div>
                                <div class="earnBox newearnBox">
                                            <div class="item">
                                                <!-- <div class="icon">
                                                    <img src="../../public/static/card1.bb2931ba.png" alt="" class="img">
                                                </div> -->
                                                <div class="dig">
                                                    <div class="number earnnumber">{{userInfo.totalReferCount}}</div>
                                                    <div class="text earntext">有效用戶</div>
                                                </div>
                                            </div>
                                            <div class="item itemright">
                                                <!-- <div class="icon">
                                                    <img src="../../public/static/card2.e85e5bb8.png" alt="" class="img">
                                                </div> -->
                                                <div class="dig">
                                                    <div class="number earnnumber">0</div>
                                                    <div class="text earntext">未参與</div>
                                                </div>
                                            </div>
                                </div>

                                <div class="inputBox newinputBox">
                                            <input placeholder="Enter Address" class="ant-input dvjUlN" type="text" :value="refer" @input="change"/>
                                            <button type="button" class="ant-btn ant-btn-default hTLDKO kmPhYp" @click="checkRecommender">
                                                <span>設置我的邀請人</span>
                                            </button>
                                </div>
                            </div>
                        </div>
                        <div class="right newright">
                            <div class="hrefLine" id="Genesis"></div>
                            <div class="ant-spin-container">
                                <div class="genesisBody">
                                    <div class="hand newhand">设置邀请人后即可成为创世者</div>
                                    <div class="introduction newintroduction">· 100.00 USDT 可以獲得 333 個 KJF 幣；
                                        <br>· 邀請 10 個用戶参與IFO，獲得超級節點一份，NFT一张；
                                        <br>· 邀請 20 個用戶参與IFO，獲得超級節點兩份，NFT兩张；
                                        <br>· 邀請 30 個用戶参與IFO，獲得超級節點三份，NFT三张；
                                        <br>· 創世者可拿直推10% USDT推薦獎勵；</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="kmlySd pagePadding newpagePadding">
                    <div class="fUeRVh itNCsf">
                        <div class="partnerBox newpartnerBox">
                            <div class="item" data-count="01">
                                <img src="data:image/png;base64,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" alt="" class="img">
                            </div>
                            <div class="item" data-count="03">
                                <img src="data:image/png;base64,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" alt="" class="img">
                            </div>
                            <div class="item" data-count="04">
                                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAABgCAYAAABsS6soAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAB+9SURBVHgB7Z0LnFVV9cfXvsPwRkWZAZUMH38lyVLTVNIiU1ErMZXyhSEWwjxA8v0EM5G/igrM8ApR4e8jybJ8iyaKUSaahVimIIKhvLR8IDAzd/9/a+07d+6de573wYCu73zOnXPv2ee9z9prr7X2OkSKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKokTFUKkZbNtTDxpECboY3/qRxVwpSNBGbPsZaqJxNN28SoqiKCGUXgBW2+n4/ClRiQRfLh9BEP6QpprHSVEUJYDSCsAqW4U91NPWZyU0wf7QBP9NiqIoPpROKxtuO0P4XUZtwx5URpej+11GiqIoPrSjUlFOP8PnF6jtOI+601z8f4EURQmmxt4G09HuHkseoHpzH31GKY0AHGn3wufF1LZ0hBC+mAbY02mBaSRFUfyxdDQ+D8j53dA/6DNM8bvA1hps9QbM7UBtz/foy5gURVE8KL4GWEvfQqtxClqUeFh4bw0twdxrmH8X85swGcx3x2dv/P8SlvFUHmOrHbDeWKq1f6QpZh0piqJkUFwBWGW7QuBMiLxdiz9DT2DuHkrSQtpAq2me2eJR0FAVdYFjY2+UOx4/1GDqTdE4EB7hs/H/VioW42w7Wkujoen2iFTeEnfBN+Bcl2OdV2gSrSJj4jYRSrEYaU9CXToicnkrzfkHqHtvoC49TzPNelI+ExRXAJbRUFSSr4eWcxVqAaZrqIIW0TiTDF4BwmIqfYyZv8lUZeshTH6I6RfY0q4URoKuohH2/qKFxWwg9i6fhX0fFGs9PusmaoD4XgWj8yJcq9nQdxeqjXIrk0AvxYqTLu56PG2iavsS1p+FWnAvehabSdluKZ4AvMDuikebK1VYbOFGlBhDH9LdNNd8kr3I8pLutJn2QJkdUMmSqGTv4/sKtLob08WmGhaGsyFEHke5KSh3SuAeLe2Mijsemtu54cK25HAXfi8c01449jNpfwj0/e0VtI7mQ/ttImVbpyOmb+De9UdjNoqG2zNRN/9JynZJkZwgEFxb6FLM7BlcDILMoPWtNzPTwm+4LYdGdyimWdCMVmA7a1Hmr1jyLP4vhAhcSu1pPYTdC5iuxrRbent1ZjU6oYNRrhpTQ+C+WWNcg4q7bZHAcR2E6RGqxFRro3brlbbHyL0rpz+hd3EqKdslxRGAVXQIKsM5IaXeQZmBEFqL07+MsbujAj0ogs7QeRCQexBRbvCypU6Yvo7p55j+DmE5lobZbrKMNbo6moa5UamutR8dcbY3QQvcWkPy4sDHNBDCfhG6V4eRsj2xE2rs3bArfoWU7Y7ChQFrcIYuwVx33zIWBmRLP4Lm96/UDwaa3JnQ9rjrcCKxtza7/CZ8/kc8w0St7WO7YH/jIBIfwzZSGidshHU0A79fQ8EcBv3yR7TtwoHjT0IIfpOUtiCJOvRJzsT1Mbhx7YAn6Q40rh1J2a4oXACW0XH4PMl3uZW/y2C3W5T6AcKPLsBvv8SXrhkl/0ts1yP6PiyT+6Eqso1sTxzhV1G2Gr8/Q9nC8Bv4/SkIi37uK4Rge5pIzrniDwvJc+wuVDpugG3osPSUINbojsN+R+H/XZi4EQh6mHZA2dnQcttyFM3nE4O604h69wnqXebUkfYl11D/llhIenMwGleNOd3OKMwJMtJyjN54zLX3LWNgy1tHt6e/V8EWZ9EVbenqskPjbmzhOrrV00u7gTg2cJydLja8BN2C74eklvGIk0dhOztE4vxuNZ9CIJ6P39iG2Jm86UvdaDiRBGsXH0Mr4W3+i8eS+fI5xnaC5jsIczxO+que27C0N7YznQbYQZE9xLW2A7a7B0wKX8AjuhO2UYa/D7FkNdxOK2i2+YiiMsDm1osB2GqmA4nL9KXeuB9st6wkZ8/8AJ8roKO/jbLRPdte+2Myz51NF+upFyy9X0StrcS+2uOI/ov9rcR5r8xykuWLRZM1DbXVO0RpFY7zKTitLpLoAy9TjTMD/ZqiwOfzDlXgfvXG+fTCul1wPtzz2YDzWUW7YWmhDjselFBNPXFefXCdepKLi/0Q02oI9TfkeSka2NcQPHM74f404ugN5pgy6cm9g/N8O/r+sK0BHtfXqw4eIE7THaQ2GFy7KeZDikFhAjCBUybyt32wFzcJ50izd7PKfgkHOZNaKs8WlBlO9XRfaFycO/GFNMQOwOlyhpkh5DTYPbCPORAAJ0tIAnezq+xU7OeigOO6BoLyHpR9m7Y2rhLcRxfZh1DdWZgPw/G08zjGE6kfvNsL6P7A7Y20++EqnIdrcAqu6u7430HM84acnmlQHTuhYtTY32N+Fk2mFwOvda2twDYeodYNyAYY+zmtGSeYqKRTsW3O9PM1/O+S2ps76iSEyDpouTV2Ls7v/2iWeSfw+Dl2lLA/Q9lauUGjt4AbS3mIB0K7GoXfvoFz7CZLbfqzCVdvJfZ3L77NaTGzlAAWyBX2Jpz/CfjmZab4On0NJqGXjL9DjhuqRjju1kFYdqBDiTX+ZEZPjPtL5fQplr+KazMNRqB5udESIbjGYiB6WnzNDpeIiubenpG5Rjx57+IZmIurN7Wg8DArPbrDcdTnYtsn4H8ltl9OzdEgSXJ1cAuEbrX9Fb7NCr1HF0AxaEDdac16aVzG0VCYGrrg+ln6Mba/P/bWNdXT5MEOu1MM8k+HdYHtg5NanFNxs7f+CG7jyVJx+MGpgKZn0jY41vxG42LMTpdnjTKBG0f0HSLpAm/GSb2S2s4LaY2Ak6xW4AIZVCRHEy7EOTTN3CPfnKB9mVzIgjdJegC3fnBeAclciZsgEIxHHKChkXD0TI+0HQ6oXgfrJdH5PiWehw/8255aoAs7Gs1z1NqG6g9fzykQLZf7apYjbCUEynIRbNmwBvtTnF8dln2XotWd9zBdiXOY47u/S+DM+pjexNYqWy15BcdxPB6dayl6PkmuU2Oh48wIFBrVlk0lXnGA83F2A0PrRLW9Cp/XeSxpxD3Z1TNQmoXSGgiIhPSY4jhMluA6nE2TzN8jlR6NBrEJ9zhJx2Q0TP4YHFVS7uv15D0W+DrUZ2/berVl08DlqA9DUC5q5qUPUfYqyI7puE4NPttls9GfPZbMlPjLBMxn1rP3tAnypBPFIE8boOWgk7GBws9xR7ri74Kbbui09BLDrTWWNzPSHoVL+ChOjIXYTzAdjXluafkCP01fxk09F9oJw6NFtqACc1iNowxnckk6/VUlLcOy4ISo3FrVyADwtoO7iZ3oQhzLGz4lDoIW2D/nV9b6GuEEIgk9iir8SMoa7K8fOnqcriwOHEtJ9Cv8ZztX1IazF6bp2N+10mjEoyPOkb373DhEraesTd4EfacOPYUuVCqS5DcSJIGjzr2ug2H2WIeH3ogGE9dbfACuw5O4598KLcnOs0Z6Avfo2EjCj7HoGhtizeyLFAd3PE9hGhpD+DEc33srtLZrfE0ffrjhsPf7CL+8yE8AjoLBl9A9CWYLbE9/ytjT6dTS9X0P328TxwVTaw+Xm2BFXfe6cWy7GIGqxV1dl2TBda0mZHjnvgLB11fmxkFAJugPFISRinp97JtQbG427Gmc4ONl5O5ltpDmcIsyeriASsDXdxgq4E9irsXabj4hOtwdugRC42cxQ5BYuxhE8UlI14iF4LgS3duE7+ijBjhNPs7+CcpCBd1MJApDvl7intjn7XR5gPOOez1Wuo3xBJmDtaboyUtq7Ek4HjbN5OuoYznADfFxsdYydCSmPlRE4gtAFhgNoi6HaRBvwZf5rsxxlzWR7q6yJP8NTTZO62GPbBNUWpOqVE4QsCZ4FaYbibtCLRyPsmMytnO/OB0cplUsIgvfMNvJYbgJNdTWdKXf4XON5zILO1umkE6g5bS0j++23PXjrkWQAZ3v+9UxA68LiRjg4x+L2vD9GOskKN99ukb0bNgNz6Nic5Foln7e3vcgEv6T9UsN7p+R4/A+F9fsNYqdLJi94fLxTjA81LLDYS62UfrIAa6LSTFLVAaU4rrXQMGhQyx0b4wZOlT0DPbxK9gBdBIOI4rkXpLW8HaBV8iSG8HhjNdPpkt1k/CCfqll7Lu8AC3mIJpqrsd0KS7jifj1yYwjHpXWAqeZD1KjRii1/qHS4jJsV3KhNWGMgj1tJ2pLbjCcKOFNn6X7wBraYtew8hCs9ii3GNemFqLmSMwfjirImuOV5LzoXvRAmTMoXwzMDOxJt9Ak2ZFlRMsJcnh0wLFdL41hfvxbuk68Lyva63hxlPjDQvemdF0pBiegG/8pXREwBnxxjue2h9iip+UIAxfjehvO4WRymjUnZ+D78Yyv4GA/q1ePpYs0/AeTP5ux7m9xv9ncMgwT5+rkHlLw6CkvnEmLw9Jae1uTqef6PPT9jiKugxwil4Sjz/gqIv1gGjiGCmMtpj+m9v0UxSR+F8GKZymKJF6WnkuIAGyf8kBtwUXJzNJ8dHp7BhVoMmx9mUbomeZdqNyjsT6/6a0sZYviyvJEqgSPLDk5Nb+buM85mqu9XPT18lswfXA8LITvobaFNeIjPX7fiTqKQ8KFsUw1b+KhPhXHvICc/Y/TiF0N/bHOYyzxs+gazcdyrhheguBYIglJigN7sVn43ATjeHYigOH2F6hR7JQZ61NH+kFv4HsV7NnOhIVBAtbiNbAFzzPZ3cshdjwaUPY+/i959UgMlrqkB+MoGp3waPdFfcsWQGypNTj2MvG2f8vz3Fxmo9k5v7NAHGOvQK1nbfu0lGhbiPo5lG4zy1uVXowG4je4Rhzl4GWiqKT9cBwLJCmIgxvvBjje/J5Jfm7K6awcJ4qFI6hGBBWHqPn3KLzgmF4ON2N7vdvvv4lH8U+BjTPXgfQUrueTKPuYzzFydqeHKQ7uWj+CesE9xL8UkpAivgboDJHhGHo/Y50d0ydv8QA1ZrQeJkNAJSHUvDxwdeafErvUsr3dM9bJdOF3gIbq7IwzpVsRJTbMoFv9NWprnAvfizI5k0ymmD+LNsAjbFiDqDOTfBMpTDUvkgvAzoXtKUNjdEGcZnItNPTxnpVupvkv9neteA79g72HxLIFGphHekBzaS38GPb0TjXslWah2+RzzD+IbAu0kuTgb8TDLTOnMnoRT8pczA/wFTQGGtXSjJ5KJhz6lBQt+VXRxMrQhc4Vfg528Fk0aORZd00qsL6FJhkQsB95sxyC9wRPDzI/Z/XmOaz/A3JaVDw4Tb6VhmUV6udxqIPzfL3ndQbPtc8ABcPHbuN1bRM0EUL/R6iDCwvNxpOPjSVagKvN8gxlqtrtsYWyjHIt+f/KfB4aDh5OZIRlGAkYbZ7PjKFqYbAYw6MmT237lEaG4nUNe9ADuF5fQeX6Q2hZS8+Rl0DiZLMVFL37n4C5YS26umEBui7QfYnP0iMg6rtTFCwe4AZ048d55YjMoBICnu3K3uyD/UWLDXPCrdxjCvNyrhMBFxS0zuYaFqAV0ALDgnWnmvdQ1jsVfaKVEyAJLc5bKHN04fmhcZjuHdr5DQpoB82b4wxnmNdCyyag9ZLnUfbClYveE7Wogz3o0qIEvlN+AjCaumol8tzRTuxQzS10B3Qo9sgo6W60gYpsaZLntjahxXRd32YtJDOQct/0nIFmOTklUHuLQOlG4cfJf49S2+NnwN6Ix29Tzq8shKaEVO5mDGyh3k1LGTrQcTTA+yOl7OJ0ZdajO+jojkofVSA9Ein5qBOQD5C3FtiZrIwYKhXrcRVPgIBbHlqyHrbe6KM7Pvb8NdeT3M+znIUJaknIsNCWsrMoHyWAtS/OyBSFpK89voOMpI5KAo1dEVPaxbcBGjFEczDzjiElW27Mp+i+tscNNbIOa2YcQ7Q0tZTHV+4FsXVOWqo3G8q7ibBkY35dxnZfg383ZQOxPBagf0b790ZaDd8iw6V6UHiY83M0FUbUtsTFL+7vs3Q1mhJvI/IIy0Ocvonz/Dam/XGuO4h1JJduEe22QSShjS2IXNr4tPhuyBzHB4YH9lpxIESD7crtRNDv7LG0+N5RZ5t8FvXsxxBsKyOtwz2ZzWJuOYbcCA0euePdSzFZSoI3ziGym8/6iyIPo+QGq9qyAI9m3mrGSqb2fXEdjk4906yM+EWH7EyF04jr9RIVkfgCkO1xVbYOF/jKwHIG3TN+sFlj6I0uwnpoehzn5zgRy2bIsnrzJ3jXzqLHUn35+7HOc3Qnyh5JbogYa5LNLcQW/HJReqhRNf0PPjPtdy3Bz84uEiakWXO4OO2tbiu6Q3gZ2ttHWP8TlpZsbx0bvrfQBKzDqf6daaB53dK96r4xy64bzgbfJYlIWmdT4DZak5SMQ6w1eT1osUYHRIJHULAddmYELdwN5/se7hkb7ffLsIcXdr8q5LnwDjBvGSQQFQ7Dii4AOVlHLbzYCQkJal/CepfJZjwJH1ARyS/Oqqv0/cMehkq0831kjlVWS/eml3Bwb4UMd3M0Cz+O3n+W7kBZDgf4Qio2sHkMI6cluhLVO2VoFsMph4S4FofDCjZnCEAjyU/DbDf3ppwEbQu/vtN62gD5EXk2S0Dz8KMGYicIj5Ao3WiHXHiEZ/TuciLg2JoovBttRVOMfn6dpavrp01FzbT9r5RDZXTG5Gfy6QWhOznUgM8Onxo0YQmxUfYtgibeQnepH97dQRPB/JNNdBt0jWVnEL8W4JRY6xWOpQ6R72Uk8hOAN5qPcNkvIxvSwWxKh6ewrskjPZq9TRxWcFRW5eGhUjuiM0qi1bTg9rEYn6dDpN6S7v+PlJCRzNx+T8OS4TzCzrN5AgXBAtx529qWUfbL+PTLKMz2rwXpb86byba1/Wjrw/veN3LpJmi03vD9DNfsnKCIbrtrQGNrfF9SFfWNgG9TPYRavWmZGuhcMbx7czI0u7MDt7gmPZyz+KNSONLBtgq8buFAioozwUS71jxe30roTAV9Bsj/pjTS3Vh7GFG6W5sLWwiG2ZmSimmSWYOWYzwu3i3EuQA/4rfHpTQbjmS3EmaQGWG/Gg/RZRDRiyE2/5VlfK+xB6Q0ys6p/byPclemt9dRgiv9Q1ucUL0K2t8qaktq7f44R9YwvO0mHGc1NSNjzVpJ/++d1p/HEyfFEcAB1dmtZAL2WEsXUqEdZCtjuR8IL4eGrRZavHfzuAn1JprzhhuxWjsxUqiDoZN8NEC+Fm9SvrATZqTlZAFPU65Jha/nFNTHF8U01Boeb52QRrbc43i5R8NZcJ7HffvIYzknINiTAuH6bjl+9KicRRa/Dbc9IjmReuFZSWY4LYMoo9GeTiUXm/cStvMQyqyiZKu7b6QhCBs+u9XJXwCyw2KEvRwnOz9gO30gjDjOaI58+xRCrhMqw1q0ss2vv+QEB53E5ndiq3U34Mbcne3xwYM1Qt7oxS2Q8yQ6L+54CArnincZVjjS3V+7NfQ62q87qK1gATESjoukJIX1G7vJFXdi1i9GApe9eAdi5SiaZbyH01XJA1x418uggeJx2xyHGES1xNMN9ln6OryT71E0DoPdjIfPBefY4+QQ1ueVDBb1aB2Fe2iD6AkNcL2MAOH0Za1tbjtKfRxuj80JzegIQdHkkWGFSdIN0DbHe8bOuRRTl1IUjAwEGObxezk6pzzWvTrQGcJd9LXookdPnvBt8juOD7HMLwtPtS1aAoNiUlhG6OlmAU78PgraPo8YcDnfiG4378OfOzEt/HhcZWcZB3wihTHc7o0Hqx4C13mNmzHQBF3WEMda6XYfGbClJqxzKQTrJtracFdjtD0UlfsunMeD5N/tSMrohtYaqvEd1fKCr/Bz68UZg+uPlbxrt8MJ499dqrX8kicOvG7ncyz3xngNaDm2MgX1x787NxLHkpBRPN7XJgHNbV6BiT+5EV5DM3Du83xK9MdxXiuCKxMX7uNlN23A/ffPgVlDB5GNPOifYzz96vJQuNdqfe2ULPzWiTNtIEWBlQvroymyhuwn/Hg/HAO5DVK4XcLIeFAWYH5ubh40fTsuwhlOm0vddNb8NokW9l2f9XbCzRmJloNDGDhxJHf9Wlpfp3LfBYF3flqg1lr2pE4WA7o/D+KReigrsKaYJFGZqm1mV4kbgZ1xTDwU6kAI630prOGx9HtoqLd4/O5nc91TKplXfFSV5W7r8VQsLB6pLei2VdtfQjzdQRtxB3aQMTe74qE+HctZc+nqszY/IPMoHr1klEWNnSP5mpvINQrlxIlbf4Arydq+X8PQiPITqRiwCWaEvRrnyO+99rKFVkHUcOjP79O/WN+EFBzyz5r/spwl1ZLx5WaKmjlmLUwfFfQ7Mh7vunHDT2/GkR2Lx24ijuZlbHUT/jriye+P54u7s9HyBjJLidOd+tXBPk7Qegj1teJM2iY1wMIF4BR0PWvsLbi41wUMEzoNF4ENyRPk+09sT9yaObiUQUkVWPB5iyk3kPxatKPT0sKPK04SXWYKfFH6ZsmmYkoY9uIGt5+c9Vu8vT2Ka+P3/uK3fNY5GJV5Ih7QG6CVr029X3k3nO0YHA+PKY06IiYazjt/NQThJdjy+3igjMR4JkMzBE1C47Mij8aHDe+jce9GyHuiXeO3I753piC7ppGkty9n9A8KY7pZgXpWRS52tVurfbEXeiacWq/Q5FRcYHvcr80yVru17TAhgeI1diiu4R8lMShnRVmP58E1IP0jHxPX/2rL4TXcyHmFfSVS9reBuHYfYH+fiofeyvG3i2UY4Uag2rKjsW/OsiRMHjV4xjfaaTizj2Uk1m60D57RKyQVni2CCaYEFNYFbobTahtfT5nbj6Gf4+LVQUs7A3rck2Ri5gJzcDQ5p/05BN3DiWmbyxi7c8ouGJavboYI7G0TNtbfBR3pVLrN+Hn2gkasXIAKvgwP1VJUxNdR0ZeTEcdHWCxkvpiUlsKJLlgghgm/RXjsJhTY+HRI7Yv32YWChd9beLzHFL2xqzdPi83Zm564izPSiXn/CmGfIL8wqy9iO/PRgCzDc7EUDdgKCBE2i0QXfi3H9DK29YuQUix0Wbvknkj3vL3SydS7bVpjRKudAHv+SpiqXoVW+ib076VkJHX91gyViUVxBCCPc+TUPsFhMayFVKOCsJYWnhXXbYvDF3jY2wPE7xxIwFtVJ5H3LUPhRtjd8bA/hAsdljxzPbZRmhchFYrFsRk6C63lT+nOANtkBT2OskEOiK7SRbUSIL4tVbpleHCGSfjU1sDKy5IGoyF5l0rBOjFPPOO5jBv2SkkX5VJHNUlmF7/YNRZC3NPhUUA9C3JUVXKCYUkZn6/AfytiOX6nj58Xn4+fx5ZzYH8fCo/DbXOKIwAZi26BiZCPK/pNfg3d5t6oPn0h8E6DxncntLdl6Radc7ONsKfjEvOg+/BW072aM6r3sfS4isr2rHrM7Ut15le+70hohlPoG8msHT2soznBbLCGHnVb3HmNLsTcvhcRj+qZZl6nuFi6k4jivbDHyDDJAeiGFnXIVBbc7WxAg+UlNJz9+QZodS4/3zTzIHFyCENRHT8M93S44x59zCvXjeWSqo4z8cQLFnaZWi6MVNYldThDRsJE3z6f+x34HzX8aatRPAHI4wmbJLV7cVp5g5vfjy9cqy4Mdy9G2mPgP30M7edcogiZRTgnWmPGSJS2g7U7fmjug+A+CzragRDuNSkNOhr8Jjsj4y7Z8L0lpPQ63OEL0S3hV5EWnj2DB6InxWnFY6eDhbWhd8Xbzglt8214ykTL4rHgHCsZFgvIwdUTcZ7fwf5eoVLDeSrbicDxEmxsDqij86xzDNbDDmYkk3lw4gBn23wC1/ibAR5nfx6TtyKOTcXTcs7NMAHKLygah1r0Xdzb6M/tVPM81uFExeyBDhO2y1HiXNTB2pzYwG2AIhsmZcwjvxFtOBUKC62N8P7yAKzu8KJukqSN/DAMEY9q9LiljeKYqDfzqViwEO4Or1a5r7ezhYT4Aj9BJXgf3tINdCOPVy2GXUoGorMx+hTs4whJK2TEqM3vYYWmDK1vCxqJZjsph980thoTy8lpP6JXsrrd/m+F49pyKDTVxeJxXg3hXS4xnvyOZvdeYJJRCWye+LUkTgjTaBn/t8LxFn8MrX+OnOv5uP9lsI8ayX/H3UXu4rOm9Bbm2QQyP/I7YV3ojNfrADagniylODhNz7setIMtdlJGeBKHgxkZAjoI/7k+c/KKBsy/h/v3F5S/C26iVdLLcd7g3EwvZbAVTo6SfEGC0Xls7/exbY6g4AQUfM1Y0K3Efh+GRfXB9Lt6+b6XeTg3OFO5X8YX96ZHjnNkD/TBuKZudIiV8br/wLq/wdKFdD7qAZftKa/PzO4WN+F4pvGbHzOeCfd2SK/4yQb8/a1YqbCY4ntmhttdcZmXpAyuhcDvFFiV4bGK9xazZvjtcz18vapKa6IIwGISSQAqSmkoXhe4Ge4aWHh84wZ/5FKOh2IvcoGX+Qk/917am1X4KYriRfEFoNvqnRQl31vpmQ2NZQkpiqJ4UBoByLYYQ5dT4VpgIbwm8YmKoig+lEYAMnX0uBim2wLnTbuZppt4IRSKonyuKJ0AdJ7Oiyj3/aGlh98RmswjjEBRlM8VJRSARCn7GweMxkmlnj9O83uWNtGZEpeoKIoSQPGz1Lam3jxMVZZfKj0IWtkRkqesFFjJn/cYfUwLAoeTKcEk5Y9fOp99n/j1U40UnlwzLrzFzvQ09pkbS2e3vZEDiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIon1f+H9QYxXUV3Y9hAAAAAElFTkSuQmCC" alt="" class="img">
                            </div>
                            <div class="item" data-count="05">
                                <img src="data:image/png;base64,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" alt="" class="img">
                            </div>
                            <div class="item" data-count="07">
                                <img src="data:image/png;base64,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" alt="" class="img">
                            </div>
                            <div class="item" data-count="09">
                                <img src="../../public/static/parter9.d154055b.png" alt="" class="img">
                            </div>
                            <div class="item" data-count="10">
                                <img src="../../public/static/parter10.8e1b6d7e.png" alt="" class="img">
                            </div>
                            <div class="item" data-count="11">
                                <img src="../../public/static/parter11.eef8e7bf.png" alt="" class="img">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="kWoIGB three">
                    <div class="fUeRVh fSzwwx">
                        <div class="footerLeft">
                            <div class="logo">
                                <div class="icon">
                                    <img src="../assets/logo.jpg" alt="" class="img">
                                </div>
                                <span class="footertext">Kjrfeevx</span>
                            </div>
                            <div class="intro footerintro">Kjrfeevx是藝術型NFT資產的先行者，
                                <br>擁有强大資深的創作團隊、技術團隊和营销團隊。
                                <br>Kjrfeevx相信NFT的價值最大化是在Web3.0的世界，是在元宇宙的世界！
                            </div>
                            <div class="iconBox">
                                <a href="http://twitter.com/kjrfeevx" rel="noreferrer" target="_blank" class="item">
                                    <svg viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4226">
                                        <path d="M1024.032 194.432c-37.664 16.704-78.176 28-120.672 33.088 43.36-26.016 76.672-67.168 92.384-116.224-40.608 24.064-85.568 41.568-133.408 50.976-38.336-40.832-92.928-66.336-153.344-66.336-116.032 0-210.08 94.048-210.08 210.08 0 16.48 1.856 32.512 5.44 47.872-174.592-8.768-329.408-92.416-433.024-219.52-18.08 31.04-28.448 67.104-28.448 105.632 0 72.896 37.088 137.184 93.472 174.88-34.432-1.088-66.816-10.528-95.168-26.272-0.032 0.864-0.032 1.76-0.032 2.656 0 101.792 72.416 186.688 168.512 205.984-17.632 4.8-36.192 7.36-55.36 7.36-13.536 0-26.688-1.312-39.52-3.776 26.72 83.456 104.32 144.192 196.256 145.888-71.904 56.352-162.496 89.92-260.928 89.92-16.96 0-33.664-0.992-50.112-2.944 92.96 59.616 203.392 94.4 322.048 94.4 386.432 0 597.728-320.128 597.728-597.76 0-9.12-0.192-18.176-0.608-27.168 41.056-29.632 76.672-66.624 104.832-108.736z" p-id="4227"></path>
                                    </svg>
                                </a>
                                <a href="https://t.me/kjrfeevx" rel="noreferrer" target="_blank" class="item">
                                    <svg viewBox="0 0 1229 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3225">
                                        <path d="M456.497009 967.347677l18.431911-283.728558L997.412172 218.72535c24.575882-18.104233-6.143971-30.187375-36.863823-12.083142L321.288698 605.099176l-276.642512-90.521166c-61.439705-18.145193-61.439705-60.41571 12.287941-90.562125L1144.949384 7.372765c49.151764-24.084364 98.344488 12.083142 79.871617 90.603085l-184.319115 863.350736c-12.287941 60.41571-49.151764 78.519943-104.447499 48.332568l-282.868402-205.290535-135.167351 132.873602c-18.431912 18.063273-30.719853 30.146415-61.521625 30.146416v-0.04096z" p-id="3226"></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="Copyrighted newCopyrighted">© 2022 Kjrfeevx. Design with by <span>Kjrfeevx</span>.</div>
                </div>
            </div>
        </div>
        <div style="position: absolute;top: 0px;left: 0px;width: 100%;">
          <div>
            <div :class="'ant-dropdown ant-dropdown-placement-bottomRight ' + mainMenuHidden" :style="'min-width: 32px; left: '+mainMenuLeftPosition+'px; top: '+mainMenuTopPosition+'px;'">
              <ul class="ant-dropdown-menu ant-dropdown-menu-root ant-dropdown-menu-vertical ant-dropdown-menu-light" role="menu" tabindex="0" data-menu-list="true">
                <li class="ant-dropdown-menu-item ant-dropdown-menu-item-only-child" role="menuitem" tabindex="-1" data-menu-id="rc-menu-uuid-80773-1-0">
                  <span class="ant-dropdown-menu-title-content">
                    <a href="#Home" @click="hiddenMainMenu">首頁</a>
                  </span>
                </li>
                <li class="ant-dropdown-menu-item ant-dropdown-menu-item-only-child" role="menuitem" tabindex="-1" data-menu-id="rc-menu-uuid-80773-1-1">
                  <span class="ant-dropdown-menu-title-content">
                    <a href="#IFO" @click="hiddenMainMenu">IFO</a>
                  </span>
                </li>
                <li class="ant-dropdown-menu-item ant-dropdown-menu-item-only-child" role="menuitem" tabindex="-1" data-menu-id="rc-menu-uuid-80773-1-2">
                  <span class="ant-dropdown-menu-title-content">
                    <a href="#Collection" @click="hiddenMainMenu">藏品</a>
                  </span>
                </li>
                <li class="ant-dropdown-menu-item ant-dropdown-menu-item-only-child" role="menuitem" tabindex="-1" data-menu-id="rc-menu-uuid-80773-1-3">
                  <span class="ant-dropdown-menu-title-content">
                    <a href="#Genesis" @click="hiddenMainMenu">合夥人</a>
                  </span>
                </li>
                <!-- <li class="ant-dropdown-menu-item ant-dropdown-menu-item-only-child" role="menuitem" tabindex="-1" data-menu-id="rc-menu-uuid-80773-1-4">
                  <span class="ant-dropdown-menu-title-content">
                    <a href="#Pool" @click="hiddenMainMenu">礦池</a>
                  </span>
                </li> -->
                <li class="ant-dropdown-menu-item ant-dropdown-menu-item-only-child" role="menuitem" tabindex="-1" data-menu-id="rc-menu-uuid-80773-1-5">
                  <span class="ant-dropdown-menu-title-content">
                    <a href="#Referral" @click="hiddenMainMenu">邀請</a>
                  </span>
                </li>
              </ul>
              <div aria-hidden="true" style="display: none;"></div>
            </div>
          </div>
        </div>
        <div style="position: absolute; top: 0px; left: 0px; width: 100%;">
            <div>
            <div :class="'ant-select-dropdown ant-select-dropdown-placement-bottomLeft ' + languageMenuHidden" :style="'min-width: 94px; width: 94px; left: ' + languageMenuLeftPosition + 'px; top: '+languageMenuTopPosition+'px;'">
              <div>
                <div role="listbox" id="rc_select_0_list" style="height: 0px; width: 0px; overflow: hidden;">
                  <div aria-label="English" role="option" id="rc_select_0_list_0" aria-selected="false">en</div>
                  <div aria-label="繁體中文" role="option" id="rc_select_0_list_1" aria-selected="false">zh</div>
                </div>
                <div class="rc-virtual-list" style="position: relative;">
                  <div class="rc-virtual-list-holder" style="max-height: 256px; overflow-y: hidden; overflow-anchor: none;">
                    <div>
                      <div class="rc-virtual-list-holder-inner" style="display: flex; flex-direction: column;">
                        <!-- <div aria-selected="false" class="ant-select-item ant-select-item-option" title="English">
                          <div class="ant-select-item-option-content" @click="hiddenLanguageMenu">English</div>
                          <span class="ant-select-item-option-state" unselectable="on" aria-hidden="true" style="user-select: none;"></span>
                        </div> -->
                        <div aria-selected="false" class="ant-select-item ant-select-item-option ant-select-item-option-active ant-select-item-option-selected" title="繁體中文">
                          <div class="ant-select-item-option-content" @click="hiddenLanguageMenu">繁體中文</div>
                          <span class="ant-select-item-option-state" unselectable="on" aria-hidden="true" style="user-select: none;"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rc-virtual-list-scrollbar" style="width: 8px; top: 0px; bottom: 0px; right: 0px; position: absolute; display: none;">
                    <div class="rc-virtual-list-scrollbar-thumb" style="width: 100%; height: 128px; top: 0px; left: 0px; position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 99px; cursor: pointer; user-select: none;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    </template>

    <script>
    import Web3 from "web3";
    import usdtContractCode from '../assets/BEP20USDT.json';
    import marketContractCode from '../assets/Market.json';
    import { Indicator } from 'mint-ui';
    import Clipboard from 'clipboard';
    export default {
      name: 'IFO',
      props: {
        msg: String
      },

      data() {
        return {
          mainMenuHidden:'ant-dropdown-hidden',
          mainMenuTopPosition: 55,
          mainMenuLeftPosition: 322,
          languageMenuHidden:'ant-select-dropdown-hidden',
          languageMenuTopPosition: 55,
          languageMenuLeftPosition: 127,
        //   usdtContractAddress: "0x7848EC33D21561b0755c423C7cf03f5018e18613",
        //   marketContractAddress: "0xa009c5546f7ff23e7f2f66177ae1d6dd9ee36a1b",
        //   fromAddress:"0xE2fcAc9dbCBCC8CBBaD00a955C7A72138D02efFe",
          usdtContractAddress: "0x55d398326f99059fF775485246999027B3197955",
          nftContractAddress: "0x7ccCeD040a8d0D593bb3Ce9342cbF3A7556382Bb",
          marketContractAddress: "0x6afF30526324b4798Cf32B007e0a87209b339333",
          fromAddress:"0xDE445dE807f09AeA1DaBE9d962939A01312dF63a",
          gasPrice: 5000000000,
          account: '',
          provider: undefined,
          marketContract:undefined,
          usdtContract:undefined,
          nftContract:undefined,
          buyAmountLimit:100,
          nftTotalSupply:0,
          referUrl: '',
          refer: new URLSearchParams('?' + window.location.href.split('?')[1]).get('refer'),
          buyBtn:'錢包授權',
          userInfo:{
              allowanceAmount:0,
              totalDeposit:0,
              totalReferCount:0,
              totalClaimNodeReward:0,
              parent:0,
              usdtBalance:0,
              nftList:[],
              lpRemainReward:0,
              nftRemainReward:0,
              nodeRemainReward:0,
          }
        }
      },

      created() {
        this.listenerFunction();
      },
      beforeDestroy () {
        document.removeEventListener("scroll", this.listenerFunction);
      },
      // 当前Vue组件被创建时回调的hook 函数
      async mounted() {
        this.handleScroll()
        await this.initWeb3Account()
        await this.initContract()
        await this.getUserInfo()
        console.log('this.refer',this.refer)
        if(this.refer=='' || this.refer==undefined){
            this.refer = '0x0000000000000000000000000000000000000000'
        }
      },
      filters: {
       handleText(value){
          if(value == undefined || value == 0 || value.toString().length < 42) return value
          else{
            return value.toString().slice(0,42) + '..'
          }
       }
      },
      methods: {
        copy(classParam) {
          var clipboard = new Clipboard(classParam)
          clipboard.on('success', error => {
            console.log('复制成功',error)
            this.$Toast("複製成功")
            // 释放内存
            clipboard.destroy()
          })
          clipboard.on('error', error => {
            // 不支持复制
            console.log('该浏览器不支持复制',error)
            // 释放内存
            clipboard.destroy()
        })
        },
        change(e) {
          let val = e.target.value;
          console.log('change()', val)
          this.refer = val
        },
        checkRecommender(){
            console.log('checkRecommender()', this.refer)
            if(this.refer!=undefined && this.refer.length==42){
                this.$Toast("設定成功")
            }else{
                this.$Toast("地址無效")
            }
        },
        listenerFunction() {
          document.addEventListener('scroll', this.handleScroll, true);
        },
        handleScroll () {
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
          var screenWidth = document.documentElement.clientWidth
        //   console.log("滚动条高度为：", scrollTop, 'width', screenWidth)
          this.mainMenuTopPosition = 55 + scrollTop
          this.languageMenuTopPosition = 55 + scrollTop
          this.mainMenuLeftPosition = screenWidth - 90
          this.languageMenuLeftPosition = screenWidth - 300
        },
        async getdynamicReward() {
        },
        changeLanguage () {
          // let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
          // this.$i18n.locale = lang
          // window.localStorage.setItem('lang', lang)
        },
        showMainMenu () {
          // console.log('this.mainMenuHidden',this.mainMenuHidden)
          if(this.mainMenuHidden==''){
            this.mainMenuHidden='ant-dropdown-hidden'
          }else if(this.mainMenuHidden=='ant-dropdown-hidden'){
            this.mainMenuHidden=''
          }
        },
        showLanguageMenu () {
          console.log('this.languageMenuHidden',this.languageMenuHidden, ' this.languageMenuLeftPosition', this.languageMenuLeftPosition)
          if(this.languageMenuHidden==''){
            this.languageMenuHidden='ant-select-dropdown-hidden'
          }else if(this.languageMenuHidden=='ant-select-dropdown-hidden'){
            this.languageMenuHidden=''
          }
        },
        hiddenMainMenu(){
          this.mainMenuHidden='ant-dropdown-hidden'
          console.log('this.ant-dropdown-hidden',this.ant-dropdown-hidden)
        },
        hiddenLanguageMenu(){
          this.languageMenuHidden='ant-select-dropdown-hidden'
          console.log('this.languageMenuHidden',this.languageMenuHidden)
        },

        // 初始化 web3及账号
        async initWeb3Account() {
          console.log("initWeb3Account start")
          if (typeof window.ethereum === "undefined") {
            //没安装MetaMask钱包进行弹框提示
            this.$Toast("Need install Metamask")
            return
          }else if(window.ethereum) {
            this.provider = window.ethereum;
            try {
              await window.ethereum.request({ method: 'eth_requestAccounts' })
              // await window.ethereum.enable();
            } catch (error) {
              this.$Toast("Metamask approve failed")
              return
            }
          } else if (window.web3) {
            this.provider = window.ethereum;
          } else {
            // this.provider = new Web3.providers.HttpProvider("https://data-seed-prebsc-1-s1.binance.org:8545/");
          }
          this.web3 = new Web3(this.provider);
          this.account = (await this.web3.eth.getAccounts().then())[0];
          this.referUrl = window.location.href.split('?')[0] + '?refer=' + this.account
          console.log("this.account",this.account);
          window.ethereum.on("accountsChanged", this.metamaskAddressChange);

        },
        // 初始化合约实例
        async initContract() {
          this.usdtContract = new this.web3.eth.Contract(usdtContractCode.abi, this.usdtContractAddress, {from: this.account})
          this.nftContract = new this.web3.eth.Contract(usdtContractCode.abi, this.nftContractAddress, {from: this.account})
          this.marketContract = new this.web3.eth.Contract(marketContractCode.abi, this.marketContractAddress, {from: this.account})

          this.nftTotalSupply = await this.marketContract.methods._nftCount().call()
        },
        async metamaskAddressChange(accounts){
          // 用户切换metamask钱包地址
          this.account = accounts[0]
          this.referUrl = window.location.href.split('?')[0] + '?refer=' + this.account
          console.log("this.account="+accounts[0]) //一旦切换账号这里就会执行
          await this.initContract()
          await this.getUserInfo()
        },
        // 获取合约的状态信息
        async getUserInfo() {
            // 获取帐号USDT余额
            this.userInfo.usdtBalance = parseFloat(this.web3.utils.fromWei(await this.usdtContract.methods.balanceOf(this.account).call()))
            // 获取帐号USDT余额
            const tmpUserInfo = await this.marketContract.methods.getUserInfo(this.account).call()
            console.log("tmpUserInfo",tmpUserInfo)
            this.userInfo.totalDeposit = parseFloat(this.web3.utils.fromWei(tmpUserInfo.totalDeposit))
            this.userInfo.totalReferCount = parseInt(tmpUserInfo.totalReferCount)
            this.userInfo.totalClaimNodeReward =  parseFloat(this.web3.utils.fromWei(tmpUserInfo.totalClaimNodeReward));
            this.userInfo.parent = tmpUserInfo.parent
            this.buyAmountLimit = parseFloat(this.web3.utils.fromWei(await this.marketContract.methods.getBuyAmountLimit().call()))

            this.userInfo.nftList = []
            let tmpNftList = await this.marketContract.methods.getMyNftList().call()
            for(let i=0;i<tmpNftList.length;i++){
                if(tmpNftList[i]!=0){ // 不为0才是真的NFT卡
                    this.userInfo.nftList.push(tmpNftList[i])
                }
            }
            if(this.userInfo.nftList.length>0){
                this.userInfo.nftRemainReward = parseFloat(this.web3.utils.fromWei(await this.marketContract.methods.getNftRemainRewad(this.account, this.userInfo.nftList).call()))
                this.userInfo.nodeRemainReward = parseFloat(this.web3.utils.fromWei(await this.marketContract.methods.getNodeRemainRewad().call()))
            }

            console.log("this.userInfo", this.userInfo)
            // 获取授权合约使用的金额
            this.refreshAllowanceAmount()
        },
        // 授权
        async approve() {
          Indicator.open({text: "正在請求授權中…",spinnerType: 'fading-circle'});
          const txDetail = await this.usdtContract.methods.approve(this.marketContractAddress, this.web3.utils.toWei("100"))
            .send({gasPrice: this.gasPrice})
            .catch((error) => {
              Indicator.close()
              console.log("call usdtContract.approve() error", error)
              if(error.message == "Invalid parameters: must provide an Ethereum address."){
                this.$Toast("Should connect to a active address")
              }else{
                this.$Toast("授權失敗")
              }
          });

          Indicator.close()
          console.log("txDetail",txDetail)
          if(undefined != txDetail && txDetail.status == true){
            this.$Toast("授權成功")
            // 刷新已授权金额
            this.refreshAllowanceAmount()
          }
        },
        async refreshAllowanceAmount(){
            // 刷新已授权金额
            this.userInfo.allowanceAmount = this.web3.utils.fromWei(await this.usdtContract.methods.allowance(this.account, this.marketContractAddress).call());
            if(this.userInfo.allowanceAmount>=100){
                this.buyBtn = "參與"
            }else{
                this.buyBtn = "錢包授權"
            }
            console.log('refreshAllowanceAmount', this.userInfo.allowanceAmount)
        },
        // 点击充值
        async buy(buyAmount) {
          console.log("buyAmount",buyAmount,"allowanceAmount",this.userInfo.allowanceAmount, "refer", this.refer)

          if(this.web3 == undefined){
            await this.initWeb3Account()
            await this.initContract()
            await this.getUserInfo()
          }
          if(this.userInfo.usdtBalance < this.buyAmountLimit){
              this.$Toast("餘額不足，最小購買100 U")
          }else if(this.userInfo.allowanceAmount < parseInt(buyAmount)){ // 没有授权使用usdt
            this.$Toast("需要授權")
            await this.approve()

          }else if(this.userInfo.totalDeposit >= this.buyAmountLimit){
              this.$Toast("最多可以購買 " + this.buyAmountLimit + "U")
          }else{
            Indicator.open({text: "交易確認中…",spinnerType: 'fading-circle'});
            const txDetail = await this.marketContract.methods.buy(this.refer==undefined?"0x0000000000000000000000000000000000000000": this.refer) // 推荐人默认填0
              .send({gasPrice: this.gasPrice})
              .catch((error) => {
                Indicator.close()
                console.log("call marketContract.buy() error", error)
                if(error.message == "Invalid parameters: must provide an Ethereum address."){
                  this.$Toast("Metamask should connect to a active address")
                }
            });
            Indicator.close()
            console.log("txDetail",txDetail)
            if(undefined != txDetail && txDetail.status == true){
                this.$Toast("購買成功");
                this.getUserInfo();
            }
          }
        },
        // 点击领取
        async claimNftReward() {
          if(this.userInfo.nftRemainReward <= 0){
              this.$Toast("待領取金額為 0");
              return;
          }else{
            Indicator.open({text: "交易確認中…",spinnerType: 'fading-circle'});
            const txDetail = await this.marketContract.methods.withdrawNftReward(this.userInfo.nftList)
              .send({gasPrice: this.gasPrice})
              .catch((error) => {
                Indicator.close()
                console.log("call marketContract.withdrawNftReward() error", error)
                if(error.message == "Invalid parameters: must provide an Ethereum address."){
                  this.$Toast("Metamask should connect to a active address")
                }
            });
            Indicator.close()
            console.log("txDetail",txDetail)
            if(undefined != txDetail && txDetail.status == true){
                this.$Toast("領取成功");
                this.getUserInfo();
            }
          }
        },
        // 点击领取
        async claimNodeReward() {
          if(this.userInfo.nodeRemainReward <= 0){
              this.$Toast("待領取金額為 0");
              return;
          }else{
            Indicator.open({text: "交易確認中…",spinnerType: 'fading-circle'});
            const txDetail = await this.marketContract.methods.withdrawNodeReward()
              .send({gasPrice: this.gasPrice})
              .catch((error) => {
                Indicator.close()
                console.log("call marketContract.withdrawNodeReward() error", error)
                if(error.message == "Invalid parameters: must provide an Ethereum address."){
                  this.$Toast("Metamask should connect to a active address")
                }
            });
            Indicator.close()
            console.log("txDetail",txDetail)
            if(undefined != txDetail && txDetail.status == true){
                this.$Toast("領取成功");
                this.getUserInfo();
            }
          }
        },
      }
    }
    </script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style lang="scss" scoped>
    #root{
        color:#000;
    }
    .img {
        width: 100%;
        height: 100%;
        display: block;
    }
      .anticon {
        display: inline-block;
        color: inherit;
        font-style: normal;
        line-height: 0;
        text-align: center;
        text-transform: none;
        vertical-align: -0.125em;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      .gCWRlV .first .content .newright{
        margin-top: 82px;
      }

      .gCWRlV .first .content .getnewright{
        @media screen and (max-width: 768px){
            margin-top: 0px;
        }
      }


      .anticon > * {
        line-height: 1;
      }

      .anticon svg {
        display: inline-block;
      }

      .anticon::before {
        display: none;
      }

      .anticon .anticon-icon {
        display: block;
      }

      .anticon[tabindex] {
        cursor: pointer;
      }

      .anticon-spin::before,
      .anticon-spin {
        display: inline-block;
        -webkit-animation: loadingCircle 1s infinite linear;
        animation: loadingCircle 1s infinite linear;
      }

      @-webkit-keyframes loadingCircle {
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }

      @keyframes loadingCircle {
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }

      .ant-btn {
          line-height: 1.5715;
          position: relative;
          display: inline-block;
          font-weight: 400;
          white-space: nowrap;
          text-align: center;
          background-image: none;
          box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
          cursor: pointer;
          transition: all .3s cubic-bezier(.645,.045,.355,1);
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          touch-action: manipulation;
          height: 32px;
          padding: 4px 15px;
          font-size: 14px;
          border-radius: 2px;
          color: rgba(0,0,0,.85);
          border: 1px solid #d9d9d9;
          background: #fff;
      }
      .ant-btn[disabled] {
          cursor: not-allowed;
      }
      .ant-btn, .ant-btn:active, .ant-btn:focus {
          outline: 0;
      }
      .ant-btn[disabled], .ant-btn[disabled]:active, .ant-btn[disabled]:focus, .ant-btn[disabled]:hover {
          color: rgba(0,0,0,.25);
          border-color: #d9d9d9;
          background: #f5f5f5;
          text-shadow: none;
          box-shadow: none;
      }
      .ant-select {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          color: rgba(0,0,0,.85);
          font-size: 14px;
          font-variant: tabular-nums;
          line-height: 1.5715;
          list-style: none;
          font-feature-settings: "tnum","tnum";
          position: relative;
          display: inline-block;
          cursor: pointer;
      }

      .ant-select:not(.ant-select-customize-input) .ant-select-selector {
          position: relative;
          background-color: #fff;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
          transition: all .3s cubic-bezier(.645,.045,.355,1);
      }
      .ant-select:not(.ant-select-customize-input) .ant-select-selector input {
          cursor: pointer;
      }
      .ant-select:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
          margin: 0;
          padding: 0;
          background: transparent;
          border: none;
          outline: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
      }
      .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
          width: 100%;
          height: 32px;
          padding: 0 11px;
      }
      .ant-select-single .ant-select-selector {
          display: flex;
      }
      .ant-select-single.ant-select-show-arrow .ant-select-selection-search {
          right: 25px;
      }
      .ant-select-single .ant-select-selector .ant-select-selection-search {
          position: absolute;
          top: 0;
          right: 11px;
          bottom: 0;
          left: 11px;
      }

      .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
          height: 30px;
      }
      .ant-select-single .ant-select-selector .ant-select-selection-search-input {
          width: 100%;
      }

      .ant-select-single .ant-select-selector .ant-select-selection-item, .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
          padding: 0;
          line-height: 30px;
          transition: all .3s;
      }
      .ant-select-selection-item {
          flex: 1 1;
          overflow: hidden;
          font-weight: 400;
          white-space: nowrap;
          text-overflow: ellipsis;
      }

      .ant-select-single .ant-select-selector .ant-select-selection-item {
          position: relative;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
      }
      .ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
          padding-right: 18px;
      }
      .ant-select-arrow {
          display: inline-block;
          color: inherit;
          font-style: normal;
          line-height: 0;
          text-transform: none;
          vertical-align: -0.125em;
          text-rendering: optimizelegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          position: absolute;
          top: 50%;
          right: 11px;
          display: flex;
          align-items: center;
          height: 12px;
          margin-top: -6px;
          color: rgba(0,0,0,.25);
          font-size: 12px;
          line-height: 1;
          text-align: center;
          pointer-events: none;
      }
      .ant-select-arrow .anticon {
          vertical-align: top;
          transition: transform .3s;
      }

      .ant-select-arrow>* {
          line-height: 1;
      }
      .anticon {
          display: inline-block;
          color: inherit;
          font-style: normal;
          line-height: 0;
          text-align: center;
          text-transform: none;
          vertical-align: -0.125em;
          text-rendering: optimizelegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
      }
      .anticon {
          display: inline-block;
          color: inherit;
          font-style: normal;
          line-height: 0;
          text-align: center;
          text-transform: none;
          vertical-align: -0.125em;
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
      }
      .ant-select-arrow .anticon>svg {
          vertical-align: top;
      }
      .ant-select-arrow svg {
          display: inline-block;
      }
      .anticon svg {
          display: inline-block;
      }
      .anticon svg {
          display: inline-block;
      }
      .anticon>* {
          line-height: 1;
      }
      .anticon > * {
          line-height: 1;
      }
      .cNPqRG {
          width: 100%;
          position: relative;
      }
      .hvZODy {
        background: rgb(255, 255, 255);
        z-index: 99;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
      }

    .elmSvn {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        justify-content: space-between;
        height: 80px;
        @media screen and (max-width: 768px){
            height: 60px;
        }
    }
    .fUeRVh {
        max-width: 1200px;
        width: 100%;
        margin: 0px auto;
        @media screen and (max-width: 414px){
            padding-right: 16px !important;
            padding-left: 16px !important;
        }
        @media screen and (min-width: 415px) and (max-width: 1200px){
            padding-right: 40px !important;
            padding-left: 40px !important;
        }
    }

    .gRvIYK {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
    }
    .gRvIYK .icon {
        width: 46px;
        border-radius: 50%;
        overflow: hidden;
        @media screen and (max-width: 768px){
            width: 36px;
            height: 36px;
        }
    }
    .gRvIYK span {
        display: block;
        margin-left: 10px;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 20px;
        @media screen and (max-width: 414px){
            display: none;
        }

        @media screen and (min-width: 415px) and (max-width: 768px){
            font-size: 18px;
        }
    }

    .blahbA {
        margin: 0px auto;
        @media screen and (max-width: 768px){
            order: 1;
            margin: 0px 0px 0px 16px;
        }
    }

    .blahbA .pcMenu {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        @media screen and (max-width: 768px){
          display: none;
        }
    }
    .blahbA .pcMenu .menuItem.active {
        color: rgb(238, 87, 76);
    }
    .blahbA .pcMenu .menuItem {
        color: rgb(24, 59, 86);
        margin-right: 22px;
        cursor: pointer;
        transition: all 0.3s ease 0s;
        font-size: 16px;
    }

    .blahbA .phoneMenu {
        width: 0px;
        height: 0px;
        overflow: hidden;
        @media screen and (max-width: 768px){
            width: 32px;
            height: 32px;
        }
    }
    .NZQce {
        margin-right: 20px;
        height: 32px;
        color: rgb(255, 255, 255);
        @media screen and (max-width: 768px){
            margin-right: 10px;
            margin-left: auto;
        }
    }
    .dOQbkG.ant-select .ant-select-selector {
        padding: 0px 8px;
        background-color: transparent;
        border: none;
        height: 32px;
        box-shadow: none !important;
    }

    [role=button], a, area, button, input:not([type=range]), label, select, summary, textarea {
        touch-action: manipulation;
    }
    [type=search] {
        outline-offset: -2px;
        -webkit-appearance: none;
    }
    .dOQbkG.ant-select .ant-select-selector .ant-select-selection-item {
        color: rgb(24, 59, 86);
        font-size: 15px;
        line-height: 32px;
    }

    .dOQbkG.ant-select .ant-select-arrow {
        color: rgb(24, 59, 86);
        right: 8px;
    }
    // [type=reset], [type=submit], button, html [type=button] {
    //     -webkit-appearance: button;
    // }

    .hTLDKO {
        height: 50px;
        border-radius: 5px;
        font-size: 15px;
        padding: 0px 20px;
        border: none;
        color: rgb(255, 255, 255);
        transition: all 0.3s ease 0s;
        cursor: pointer;
        font-family: Arial, sans-serif;
        font-weight: bold;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 10px 20px 0px;
        @media screen and (max-width: 768px){
            height: 40px;
            font-size: 15px;
            box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 6px;
        }
    }

    .gwMTjx {
        border: none;
        height: 38px;
        padding: 0px 26px;
        min-width: 95px;
        max-width: 200px;
        background: #565DFF;
        box-shadow: 4px 4px 20px 0px rgba(0,0,0,0.1);
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #56FFFF;
        @media screen and (max-width: 768px){
            height: 32px;
            padding: 0px 10px;
        }
    }

    .gCWRlV .first {
        padding: 100px 0px 0;
        min-height: 70vh;
        background: rgba(250, 192, 57, 0.1);
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        @media screen and (max-width: 414px){
            padding: 100px 0px 40px;
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            padding: 120px 0px 60px;
        }
        @media screen and (min-width: 768px) and (max-width: 1024px){
            min-height: auto;
            padding: 180px 0px 100px;
        }
    }
    .gCWRlV > div {
        position: relative;
    }

    .gCWRlV .first .content {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        justify-content: space-between;
        @media screen and (max-width: 414px){
            flex-wrap: wrap;
        }
    }

    .gCWRlV .first .content .left {
        width: 50%;
        @media screen and (max-width: 414px) {
            width: 100%;
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            width: calc(50% - 20px);
        }
    }
    .gCWRlV .first .content .left .firstHand {
        font-size: 56px;
        font-weight: bold;
        line-height: 1.4;
        @media screen and (max-width: 768px){
            font-size: 32px;
        }
    }
    .gCWRlV .firstHand {
        font-size: 56px;
        font-weight: bold;
        line-height: 1.4;
        @media screen and (max-width: 768px){
            font-size: 32px;
        }
    }
    .gCWRlV .first .content .left .firstIntro {
        color: rgba(107, 110, 111, 0.8);
        margin: 56px 0px;
        font-size: 18px;
        line-height: 1.5;
        @media screen and (max-width: 768px){
            margin: 26px 0px;
            font-size: 14px;
        }
    }
    .gCWRlV .firstIntro {
        color: rgba(107, 110, 111, 0.8);
        margin: 26px 0px;
        font-size: 18px;
        line-height: 1.5;
        @media screen and (max-width: 768px){
            margin: 26px 0px;
            font-size: 14px;
        }
    }
    .gCWRlV .first .content .left .btnBox {
        display: flex;
        @media screen and (max-width: 768px){
            display: flex;
            -webkit-box-pack: justify;
            justify-content: space-between;
        }
    }
    .gCWRlV .first .content .left .btnBox .ant-btn:last-child {
        margin-right: 0px;
    }
    .gCWRlV .first .content .left .btnBox .ant-btn {
        width: 150px;
        margin-right: 20px;
        @media screen and (max-width: 768px){
            width: calc(50% - 10px);
            margin: 0px;
        }
    }
    [type=reset], [type=submit], button, html [type=button] {
        -webkit-appearance: button;
    }
    .kmPhYp {
        background: rgb(24, 59, 86);
    }
    .gCWRlV .first .content .left .btnBox .twokmPhYp {
        @media screen and (max-width: 768px){
            margin: 30px 0;
        }
    }
    .ant-btn>a:only-child {
        color: currentcolor;
    }
    .ant-btn[disabled]>* {
        pointer-events: none;
    }
    .ant-btn>span {
        display: inline-block;
    }
    .gCWRlV .first .content .left .line {
        margin: 56px 0px;
        border-bottom: 1px solid rgb(222, 226, 230);
        @media screen and (max-width: 414px){
            margin: 26px 0px;
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            margin: 36px 0px;
        }
    }
    .gCWRlV .first .content .left .count-detail {
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(3, 1fr);
        @media screen and (max-width: 414px){
            grid-template-columns: repeat(3, 1fr);
            margin-bottom: 26px;
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            display: grid;
            gap: 20px;
            grid-template-columns: repeat(2, 1fr);
        }
    }

    .gCWRlV .count-detail {
        display: grid;
        gap: 20px;
        max-width: 800px;
        padding:40px 0;
        margin:56px auto;
        text-align: center;
        background: rgba(86,255,255,0.1);
        box-shadow: 0px 1px 20px 0px rgba(0,0,0,0.12);
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #FFFFFF;
        filter: blur(undefinedpx);
        grid-template-columns: repeat(3, 1fr);
        @media screen and (max-width: 414px){
            grid-template-columns: repeat(3, 1fr);
            margin-bottom: 26px;
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            display: grid;
            gap: 20px;
            grid-template-columns: repeat(2, 1fr);
        }
    }

    .gCWRlV .first .content .left .count-detail .item .number {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 10px;
        @media screen and (max-width: 414px){
            font-size: 18px;
            margin-bottom: 5px;
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            font-size: 24px;
            margin-bottom: 10px;
        }
    }

    .gCWRlV .count-detail .item .number {
        color:#000;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 17px;
        @media screen and (max-width: 414px){
            font-size: 14px;
            margin-bottom: 8px;
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            font-size: 24px;
            margin-bottom: 8px;
        }
    }

    .gCWRlV .first .content .left .count-detail .item .text {
        color: #000;
        font-size:16px;
        @media screen and (max-width: 414px){
            font-size: 13px;
        }
    }

    .gCWRlV .count-detail .item .text {
        color: rgba(107, 110, 111, 0.8);
        @media screen and (max-width: 414px){
            font-size: 13px;
        }
    }

    .gCWRlV .first .content .right {
        width: 35%;
        @media screen and (max-width: 414px){
            width: 100%;
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            width: calc(50% - 20px);
        }
    }
    .gCWRlV .first .content .right .card-body {
        background-color: rgb(224, 255, 102);
        padding: 36px;
        font-weight: bold;
    }
    .gCWRlV .first .content .right .card-body .name {
        font-size: 26px;
        margin-bottom: 16px;
    }
    .gCWRlV .hrefLine {
        position: absolute;
        top: -60px;
        z-index: -1;
        left: 0px;
        width: 100%;
        height: 60px;
    }
    .bZRkxy .icoHand {
        text-align: center;
        font-size: 56px;
        font-weight: bold;
        @media screen and (max-width: 768px){
            font-size: 36px;
        }
    }
    .bZRkxy .icoIntro {
        text-align: center;
        margin: 36px 0px 56px;
        line-height: 1.4;
        @media screen and (max-width: 768px){
            font-size: 14px;
            margin: 26px 0px 36px;
        }
    }
    .ant-spin-nested-loading {
        position: relative;
    }
    .ant-spin-container {
        position: relative;
        transition: opacity .3s;
    }
    .bZRkxy .icoList {
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(3, 1fr);
        @media screen and (max-width: 414px){
            grid-template-columns: repeat(1, 1fr);
        }
        @media screen and (min-width: 415px) and (max-width: 768px){
            grid-template-columns: repeat(2, 1fr);
        }
    }
    .bZRkxy .icoList .icoItem {
        border: 1px solid rgba(107, 110, 111, 0.2);
        border-radius: 10px;
        overflow: hidden;
    }
    .bZRkxy .icoList .icoItem .cardBody {
        padding: 16px;
    }
    .bZRkxy .icoList .icoItem .cardBody .name {
        font-weight: bold;
        font-size: 22px;
        margin-bottom: 16px;
    }
    .bZRkxy .icoList .icoItem .cardBody .infoBox {
        display: grid;
        gap: 16px 10px;
        grid-template-columns: repeat(1, 1fr);
        margin-bottom: 16px;
    }
    .infoBox {
        display: grid;
        gap: 16px 10px;
        grid-template-columns: repeat(3, 1fr);
        margin-bottom: 16px;
    }
    .bZRkxy .icoList .icoItem .cardBody .price {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        font-weight: bold;
    }
    .bZRkxy .icoList .icoItem .cardBody .price .number {
        font-size: 16px;
        color: rgb(29, 155, 123);
        margin-left: 10px;
    }
    .bZRkxy .icoList .icoItem .cardBody .total .number {
        color: rgb(238, 87, 76);
    }
    .bZRkxy .icoList .icoItem .cardBody .troIco {
        font-size: 14px;
        margin-bottom: 16px;
    }
    .bZRkxy .icoList .icoItem .btnBox {
        border: 1px solid rgba(107, 110, 111, 0.2);
        border-radius: 10px;
        padding: 10px;
    }
    .bZRkxy .icoList .icoItem .btnBox .ant-btn {
        width: 100%;
    }

    .gCWRlV .pagePadding {
        padding: 100px 0px;
        @media screen and (max-width: 414px){
            padding: 40px 0px;
        }
        @media screen and (min-width: 415px) and (max-width: 1024px){
            padding: 80px 0px;
        }
    }
    .iUnQag {
        background: rgb(248, 249, 252);
    }
    .cKxBZe .collectionHand {
        font-size: 36px;
        margin-bottom: 36px;
        font-weight: bold;
    }
    .kWoIGB {
        margin-top: auto;
        position: relative;
        background-color: rgb(24, 31, 45);
        color: rgb(255, 255, 255);
    }
    .fSzwwx {
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        padding: 40px 0px;
        @media screen and (max-width: 414px){
            flex-flow: column;
        }
    }
    .fSzwwx .footerLeft {
        max-width: 50%;
        @media screen and (max-width: 414px){
            width: 100%;
            max-width: 100%;
            margin-bottom: 20px;
        }
    }
    .fSzwwx .footerLeft .logo {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        margin-bottom: 20px;
        @media screen and (max-width: 414px){
            margin-bottom: 16px;
        }
    }
    .fSzwwx .footerLeft .logo span {
        font-weight: bold;
        font-size: 20px;
        @media screen and (max-width: 414px){
            font-size: 18px;
        }
    }
    .fSzwwx .footerLeft .intro {
        line-height: 1.5;
        font-size: 14px;
        @media screen and (max-width: 414px){
            font-size: 13px;
        }
    }
    /* @media screen and (max-width: 414px) */
    .fSzwwx .footerRight {
        width: 100%;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
    }
    .fSzwwx .footerRight .hand {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 20px;
        @media screen and (max-width: 414px){
            margin-bottom: 0px;
            line-height: 35px;
        }
    }
    .fSzwwx .iconBox {
        display: flex;
        @media screen and (max-width: 414px){
            -webkit-box-pack: start;
            justify-content: flex-start;
        }
    }
    .fSzwwx .iconBox .item {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        padding: 7px;
        margin-right: 10px;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
    }
    .fSzwwx .iconBox .item svg {
        fill: rgb(24, 31, 45);
    }
    .fSzwwx .footerRight .iconBox .item:last-child {
        margin-right: 0px;
    }



    .kWoIGB .newCopyrighted {
        text-align: center;
        padding: 20px 0px;
        color:#000;
        @media screen and (max-width: 414px){
            font-size: 13px;
        }
    }
    .ant-dropdown {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        color: rgba(0,0,0,.85);
        font-size: 14px;
        font-variant: tabular-nums;
        line-height: 1.5715;
        list-style: none;
        font-feature-settings: "tnum","tnum";
        position: absolute;
        top: -9999px;
        left: -9999px;
        z-index: 1050;
        display: block;
    }
    .ant-dropdown-menu {
        position: relative;
        margin: 0;
        padding: 4px 0;
        text-align: left;
        list-style-type: none;
        background-color: rgba(0,0,0,.5);
        -webkit-backdrop-filter: blur(4px);
        backdrop-filter: blur(4px);
        background-clip: padding-box;
        border-radius: 2px;
        outline: none;
        box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    }
    li, ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
        clear: both;
        margin: 0;
        padding: 5px 12px;
        color: rgba(0,0,0,.85);
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        cursor: pointer;
        transition: all .3s;
        position: relative;
        display: flex;
        align-items: center;
    }
    .ant-dropdown-menu-item {
        color: #fff;
        padding: 6px 16px;
    }
    .ant-dropdown-menu-title-content {
        flex: auto;
    }
    .ant-dropdown-menu-title-content>a {
        color: inherit;
        transition: all .3s;
    }
    .ant-dropdown:before {
        position: absolute;
        top: -4px;
        right: 0;
        bottom: -4px;
        left: -7px;
        z-index: -9999;
        opacity: .0001;
        content: " ";
    }
    .ant-dropdown-hidden, .ant-dropdown-menu-hidden, .ant-dropdown-menu-submenu-hidden {
        display: none;
    }
    .gCWRlV .first .content .right .card-body .ant-btn {
        width: 150px;
    }
    .cKxBZe .pendingReward {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        justify-content: space-between;
        border: 1px solid rgba(107, 110, 111, 0.2);
        border-radius: 10px;
        padding: 10px 16px;
        margin-bottom: 26px;
        @media screen and (max-width: 414px){
            flex-flow: column;
            margin-bottom: 16px;
            padding: 26px 16px;
        }
    }
    .cKxBZe .pendingReward .text {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        font-weight: bold;
        font-size: 18px;
        @media screen and (max-width: 414px){
            font-size: 16px;
            margin-bottom: 16px;
        }
    }
    .cKxBZe .pendingReward .text span {
        color: rgb(238, 87, 76);
        margin-left: 10px;
    }
    .cKxBZe .pendingReward .number .ant-btn {
        width: 150px;
    }
    .noData {
        width: 100%;
        min-height: 100px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 700;
    }
    .zicj .genesisBody {
        padding: 40px;
        position: relative;
        z-index: 1;
        color: rgb(255, 255, 255);
        display: flex;
        flex-flow: column;
        -webkit-box-align: center;
        align-items: center;
        font-weight: bold;
        @media screen and (max-width: 414px){
            padding: 26px;
        }
    }
    .zicj .genesisBody .hand {
        font-size: 36px;
        margin-bottom: 36px;
        @media screen and (max-width: 414px){
            font-size: 26px;
            margin-bottom: 26px;
        }
    }
    .zicj .genesisBody .introduction {
        line-height: 1.4;
        margin-bottom: 36px;
        @media screen and (max-width: 414px){
            font-size: 14px;
            font-weight: normal;
            margin-bottom: 26px;
            line-height: 2;
        }
    }
    .zicj .genesisBody .ant-btn {
        min-width: 165px;
        padding: 0px 20px;
        margin-right: 16px;
        @media screen and (max-width: 414px){
            min-width: auto;
            width: calc(50% - 8px);
            margin: 0px;
        }
    }
    .zicj .genesisBody .ant-btn:last-child {
        margin: 0px;
    }
    .zicj .genesisBody::before {
        content: "";
        position: absolute;
        z-index: -1;
        top: 0px;
        left: 0px;
        right: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(250, 250, 250, 0.25);
        backdrop-filter: blur(25px);
        border-radius: 15px;
        border: 1px solid rgba(250, 250, 250, 0.5);
    }
    .SRwGx {
        background: rgb(238, 87, 76);
    }
    .jJndeq {
        background-position: center center;
        background-size: cover;
    }
    .iUHatv .referralHand {
        text-align: center;
        font-size: 56px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
            font-size: 36px;
        }
    }
    .iUHatv .referralIntro {
        margin: 36px 0px 56px;
        line-height: 1.4;
        text-align: center;
        @media screen and (max-width: 768px){
            font-size: 14px;
            margin: 26px 0px 36px;
        }
    }
    .iUHatv .invBox {
        display: flex;
        align-items: flex-start;
        @media screen and (max-width: 768px){
            flex-flow: column;
        }
    }
    .iUHatv .invBox .left {
        border: 1px solid rgba(107, 110, 111, 0.3);
        padding: 26px;
        border-radius: 10px;
        width: 30%;
        @media screen and (max-width: 768px){
            width: 100%;
        }
    }
    .iUHatv .invBox .left .title {
        font-weight: bold;
        font-size: 20px;
        background-image: -webkit-linear-gradient(left, rgb(31, 134, 239), rgb(31, 134, 239), rgb(255, 182, 11), rgb(241, 62, 116), rgb(218, 55, 70));
        background-clip: text;
        -webkit-text-fill-color: transparent;
        display: inline-block;
    }
    .iUHatv .invBox .left .inputBox {
        margin: 26px 0px;
    }
    .iUHatv .invBox .left .inputBox .text {
        margin-bottom: 5px;
        font-size: 13px;
    }
    .iUHatv .invBox .left .inputBox .ant-input {
        color: rgb(24, 59, 86);
        font-size: 12px;
        height: 46px;
        border: 1px solid rgba(107, 110, 111, 0.3);
        border-radius: 5px;
    }
    .ant-input {
        box-sizing: border-box;
        margin: 0;
        font-variant: tabular-nums;
        list-style: none;
        font-feature-settings: "tnum","tnum";
        position: relative;
        display: inline-block;
        width: 100%;
        min-width: 0;
        padding: 4px 11px;
        color: rgba(0,0,0,.85);
        font-size: 14px;
        line-height: 1.5715;
        background-color: #fff;
        background-image: none;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        transition: all .3s;
    }
    .ant-input:placeholder-shown {
        text-overflow: ellipsis;
    }
    .dvjUlN {
        border: none;
        outline: none;
        background-color: transparent;
        padding: 0px 16px;
        font-size: 16px;
        color: rgb(255, 255, 255);
        height: 56px;
        border-radius: 8px;
        width: 100%;
        line-height: 46px;
        box-shadow: none !important;
    }
    .iUHatv .invBox .left .inputBox .ant-btn {
        width: 100%;
        height: 40px;
        margin-top: 16px;
    }
    .iUHatv .invBox .left .earnBox {
        display: flex;
    }
    .iUHatv .invBox .left .earnBox .item {
        display: flex;
        width: 50%;
    }
    .iUHatv .invBox .left .earnBox .item .icon {
        width: 26px;
        height: 26px;
        margin-right: 10px;
        border-radius: 50%;
        overflow: hidden;
    }
    .iUHatv .invBox .left .earnBox .item .text {
        font-size: 14px;
    }
    .iUHatv .invBox .left .earnBox .item .number {
        font-weight: bold;
        font-size: 22px;
        margin-bottom: 10px;
    }
    .iUHatv .invBox .left .earnBox .item:nth-child(1) .number {
        color: rgb(29, 155, 123);
    }
    .itNCsf .partnerHand {
        font-size: 56px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 56px;
        @media screen and (max-width: 768px){
            font-size: 36px;
            margin-bottom: 36px;
        }
    }
    .itNCsf .partnerBox {
        display: grid;
        gap: 20px 40px;
        grid-template-columns: repeat(4, 1fr);
        @media screen and (max-width: 414px){
            grid-template-columns: repeat(2, 1fr);
        }
    }
    .itNCsf .partnerBox .item {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
    }
    .itNCsf .partnerBox .item img {
        height: auto;
    }
    .fSzwwx .footerLeft .logo {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        margin-bottom: 20px;
        @media screen and (max-width: 414px){
          margin-bottom: 16px;
        }
    }
    .fSzwwx .footerLeft .logo span {
        font-weight: bold;
        font-size: 20px;
        @media screen and (max-width: 414px){
            font-size: 18px;
        }
    }
    .fSzwwx .footerLeft .logo .icon {
        width: 45px;
        margin-right: 10px;
        @media screen and (max-width: 414px){
            width: 36px;
            height: 36px;
        }
    }
    .kWoIGB .Copyrighted span {
        color: rgb(238, 87, 76);
    }
    .ant-select-dropdown {
        margin: 0;
        color: rgba(0,0,0,.85);
        font-variant: tabular-nums;
        line-height: 1.5715;
        list-style: none;
        font-feature-settings: "tnum","tnum",;
        position: absolute;
        top: -9999px;
        left: -9999px;
        z-index: 1050;
        box-sizing: border-box;
        padding: 4px 0;
        overflow: hidden;
        font-size: 14px;
        font-variant: normal;
        background-color: #fff;
        border-radius: 2px;
        outline: none;
        box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    }
    .ant-select-dropdown-hidden {
        display: none;
    }
    .ant-select-item, .ant-select-item-empty {
        position: relative;
        display: block;
        min-height: 32px;
        padding: 5px 12px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
    }
    .ant-select-item-option {
        display: flex;
    }
    .ant-select-item-option-content {
        flex: auto;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .ant-select-item-option-state {
        flex: none;
    }
    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
        background-color: #f5f5f5;
    }
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        color: rgba(0,0,0,.85);
        font-weight: 600;
        background-color: #e6f7ff;
    }
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
        color: #1890ff;
    }
    .gCWRlV .newfirst{
        padding-bottom:0;
        width:100%;
        background-image: url('../assets/earththree.png');
        background-position: center center;
        background-size: cover;
        // background-color:#ffecf6;
        // background-image: -webkit-gradient(linear,left,right,from(#ffecf6),color-stop(100%,#f8f1ff));
        // background-image: linear-gradient(left,#e7e7e7,#fbdaff 50%,#f8f1ff 100%);
        // background-image: -webkit-linear-gradient(left,#e7e7e7,#fbdaff 50%,#f8f1ff 100%);
    }
    .newkmPhYp{
        padding:0 50px;
        background: #565DFF;
        box-shadow: 4px 4px 20px 0px rgba(0,0,0,0.1);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        border: 1px solid #56FFFF;
        color:#fff;
    }
    .kmPhYpmoney{
        padding:0 100px;
        background: #000;
        box-shadow: 4px 4px 20px 0px rgba(0,0,0,0.1);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        border: 1px solid #56FFFF;
        color:#fff;
        margin-bottom:40px;
    }
    .gCWRlV .two{
        background-color:#f5ffff;
        background-image: -webkit-gradient(linear,top,bottom,from(#f5ffff),color-stop(100%,#f6e9f8));
        background-image: linear-gradient(top,#f5ffff 10%,#edffff 20%,#e3ffff 30%,#d6feff 40%,#d2efff 50%,#d3edff 60%,#d2f0ff 70%,#d5ebff 80%,#dde8ff 90%,#f6e9f8 100%);
        background-image: -webkit-linear-gradient(top,#f5ffff 10%,#edffff 20%,#e3ffff 30%,#d6feff 40%,#d2efff 50%,#d3edff 60%,#d2f0ff 70%,#d5ebff 80%,#dde8ff 90%,#f6e9f8 100%);
    }
    .gCWRlV .three{
        background-color:#ffdeff;
        background-image: -webkit-gradient(linear,left,right,from(#ffe9d6),color-stop(100%,#ffdeff));
        background-image: linear-gradient(left,#ffdeff,#ffe9d6 50%,#ffdeff 100%);
        background-image: -webkit-linear-gradient(left,#ffdeff,#ffe9d6 50%,#ffdeff 100%);
    }
    .newicoHand{
        font-size: 36px;
        font-weight: bold;
        color: #000;
        @media screen and (max-width: 768px){
            padding-top:20px;
            font-size: 18px;
        }
    }

    .gCWRlV .first .getcontent{
        margin-top:-150px;
        @media screen and (max-width: 768px){
            margin-top:-100px;
        }
    }
    .newicoIFO{
        @media screen and (max-width: 768px){
            margin-top: -50px;
        }
    }
    .newname{
        margin-top:30px;
        font-size: 29px;
        font-family: 'Noah-Bold, Noah';
        font-weight: bold;
        color: #565DFF;
        @media screen and (max-width: 768px){
            font-size: 16px;
            margin-top:20px;
        }
    }
    .newicoIntro{
        margin-top:56px;
        font-size: 19px;
        font-weight: 400;
        @media screen and (max-width: 768px){
            font-size: 14px;
            margin-top:20px;
        }
    }
    .twokmPhYp{
        margin:40px 0;
        background: #565DFF;
        box-shadow: 4px 4px 20px 0px rgba(0,0,0,0.1);
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #56FFFF;
        color:#fff;
    }
    .newnumber{
        margin-bottom:17px;
        font-size: 24px;
        font-family: 'Noah-Bold, Noah';
        font-weight: bold;
        color: #000;
        @media screen and (max-width: 768px){
            font-size: 14px;
        }
    }
    .newtext{
        font-size: 16px;
        font-weight: normal;
        @media screen and (max-width: 768px){
            font-size: 12px;
        }
    }
    .newleft{
        padding:30px;
        margin-top:37px;
        background: rgba(86,255,255,0.1);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        border: 1px solid #FFFFFF;
        filter: blur(undefinedpx);
    }
    .newpendingReward{
        margin-bottom:40px;
        padding:25px 40px;
        display: flex;
        justify-content: space-between;
        background: rgba(86,255,255,0.1);
        box-shadow: 0px 1px 20px 0px rgba(0,0,0,0.12);
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #FFFFFF;
        filter: blur(undefinedpx);
    }
    .newSRwGx{
        background: #000;
        box-shadow: 4px 4px 20px 0px rgba(0,0,0,0.1);
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #56FFFF;
        color:#fff;
    }
    .newnoData{
        display: block;
    }
    .newhand{
        font-size: 24px;
        font-family: 'HarmonyOS Sans SC-Bold, HarmonyOS Sans SC';
        font-weight: bold;
        color: #000;
        line-height: 28px;
        @media screen and (max-width: 768px){
            margin-top:-100px;
            font-size:16px;
        }
    }
    .newintroduction{
        margin-top:11px;
        font-size: 16px;
        font-family: 'HarmonyOS Sans SC-Regular, HarmonyOS Sans SC';
        font-weight: 400;
        color: #000;
        line-height: 30px;
        @media screen and (max-width: 768px){
            font-size:13px;
        }
    }
    .newtitle{
        font-size: 22px;
        font-family: 'HarmonyOS Sans SC-Medium, HarmonyOS Sans SC';
        font-weight: 500;
        line-height: 26px;
        @media screen and (max-width: 768px){
            font-size:14px;
        }
    }
    .copytext{
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 768px){
            display: grid;
            gap: 20px;
            grid-template-columns: repeat(1, 1fr);
        }
    }
    .contract-copy{
        margin-top:8px;
        color: #565DFF;
        font-size: 14px;
    }
    .newearnBox{
        margin-top:20px;
        display: flex;
    }
    .itemright{
        margin-left:70px;
    }
    .earnnumber{
        font-size:24px;
        margin-bottom:20px;
        font-weight: bold;
    }
    .earntext{
        font-size:14px;
        @media screen and (max-width: 768px){
            font-size:13px;
        }
    }
    .newinputBox{
        margin-top:50px;
        display:flex;
        @media screen and (max-width: 768px){
            display: grid;
            gap: 20px;
            grid-template-columns: repeat(1, 1fr);
        }
    }
    .newinputBox input{
        box-shadow: 4px 4px 20px 0px rgba(0,0,0,0.1);
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #565DFF;
        color:#565DFF;
        font-size: 19px;
        font-weight: bold;
    }
    .newinputBox button{
        background: #000;
        box-shadow: 4px 4px 20px 0px rgba(0,0,0,0.1);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        border: 1px solid #56FFFF;
        color:#fff;
        margin-left:20px;
        @media screen and (max-width: 768px){
            margin-left:0px;
        }
    }
    .itNCsf .newpartnerBox{
        grid-template-columns: repeat(8, 1fr);
        @media screen and (max-width: 768px){
            grid-template-columns: repeat(4, 1fr);
        }
    }
    .gCWRlV .newpagePadding{
        padding:50px 0;
    }
    .footertext{
        color:#000;
    }
    .fSzwwx .footerLeft .footerintro{
        color:#000;
        line-height: 2;
    }
    .gCWRlV .first .newcontent {
        @media screen and (max-width: 768px){
            display: grid;
            gap: 20px;
            grid-template-columns: repeat(1, 1fr);
            }
    }
    .newleft{
        @media screen and (max-width: 768px){
            width:100%;
            margin:50px auto;
            }
    }
    .getmoney{
        margin-bottom:10px;
        font-size:24px;
        font-weight: bold;
        @media screen and (max-width: 768px){
            font-size:16px;
            }
    }
    .copylink{
        margin-top:10px;
        font-size:14px;
        width:90%;
        word-break: break-all;
        @media screen and (max-width: 768px){
            font-size:12px;
            }
    }
    </style>
